import * as React from 'react';
import * as cn from 'classnames';
import * as styles from './styles.css';

export interface ITabProps {
  children: React.ReactNode;
  isActive: boolean;
  isNextTabActive: boolean;
  disabled?: boolean;
  onClick?(): void;
}

export function Tab({ children, isNextTabActive, isActive, disabled, onClick }: ITabProps) {
  return (
    <div
      className={cn(
        styles['tab'],
        isActive && styles['active'],
        // рендер метод не добавляет css класс,
        // если к нему применяются стили только псевдокласса(next-tab-active::after)
        /* istanbul ignore next */
        isNextTabActive && styles['next-tab-active'],
        disabled && styles['disabled'],
      )}
      onClick={() => onClick && onClick()}
    >
      {children}
    </div>
  );
}
